export default __webpack_public_path__ + "static/base-lite-3-345f5fd41208a7529342d18d30812a49.jpg";